import NoticeRegisterContainer from './NoticeRegisterContainer';

export default NoticeRegisterContainer;
